
import { useMapStore, usePlacesStore } from "@/composables";
import { defineComponent } from "@vue/runtime-core";
import { computed } from 'vue'


export default defineComponent( {
    name: 'MyLocationBtn',
    setup() {

        const { isLoading, userLocation, isUserlocationReady } = usePlacesStore()
        const { map, isMapReady } = useMapStore()
        return {

            isBtnready : computed <boolean>( ()=> isUserlocationReady.value && isMapReady.value ),

            onMyLocationClicked : () => {
                map.value?.flyTo({
                    center: userLocation.value ,
                    zoom: 14
                })
            },


        }
    }
})
